import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import DropDown from '../../../components/DropDown';
import { useState } from 'react';
import { useCreateFolderMutation } from '../../../features/authentication/assignmentApislice';
import CustomToast from '../../../components/Toast';
import ActivityTypes from '../../../enums/activityTypes';

const FolderCreateModal = ({
  isOpen,
  onClose,
  allParents,
  setSelectedFolderId,
  setSelectedFolderName,
  setReloadFolders,
  activityType
}) => {
  const [newFolderName, setNewFolderName] = useState('');
  const [parentFolderId, setParentFolderId] = useState(-1);
  const [createFolder] = useCreateFolderMutation();

  const handleNewFolder = (event) => {
    const folderName = event.target.value;
    setNewFolderName(folderName);
  };

  const handleSelectFolder = (event) => {
    const folderId = parseInt(event.target.value);
    setParentFolderId(folderId);
  };

  const createNewFolder= async () => {
    if (newFolderName.length === 0) {
      CustomToast('Folder name cannot be empty.', 'warning');
      return;
    }
    let parentId = 0;
    let updatedFolderName = newFolderName;

    if (parentFolderId !== -1) 
      parentId = parentFolderId;
    
    if (parentFolderId > 0){
      const parentInfo = allParents.filter((item)=>item.id === parentFolderId);
      if (parentInfo.length > 0){
        updatedFolderName = parentInfo[0].name+'/'+ newFolderName;
      }
    }
        
    try {
      const options = {
        ParentId: parentId,
        Name: newFolderName
      };
      const response = await createFolder(options);
      if (response.error) {
        if(response.error.data.errors)
          CustomToast(response.error.data.errors.Name, 'error');
        else
          CustomToast(response.error.data.error, 'error');
      }
      else if(response.data){
        setReloadFolders(true);
        setSelectedFolderId(response.data);
        setSelectedFolderName(updatedFolderName);
        CustomToast('Folder created successfully', 'success');
      }
      onClose(false);
    } catch (error) {
      console.log(error);
    }
  };
  
  return (
    <Modal
      contentWidth="600px"
      isOpen={isOpen}
      titleName={`Create New ${activityType === ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'} Folder`}
      onClose={() => onClose(false)}
      titleToolTip='To create a subfolder select a parent folder from the dropdown. If you wish to create a new parent and subfolder you should enter the folder name as parent/subfolder. The new parent folder will automatically be created. Only one sublevel is allowed.'>
      <div>
        <div className="mb-3">
          <label htmlFor="createFolderName" className="form-label">
                  New folder name
          </label>
          <input
            type="text"
            className="form-control"
            placeholder=" "
            name="createFolderName"
            id="createFolderName"
            onChange={(e) => handleNewFolder(e)}
            required
          />
        </div>
        <DropDown
          label="Parent Folder"
          value={allParents}
          onChangeHandler={(e) => handleSelectFolder(e)}
          selectedValue={parentFolderId}
        />
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => {
              onClose(false);
            }}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={()=>createNewFolder()}>
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

FolderCreateModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  allParents: PropTypes.array,
  setSelectedFolderId: PropTypes.func,
  setSelectedFolderName: PropTypes.func,
  setReloadFolders: PropTypes.func,
  activityType: PropTypes.number
};

export default FolderCreateModal;
